<template>
    <div class="index">

             <div class="wrapper">
                <swiper :options="swiperOption"  v-if="qtz_banner.length!=0">
                    <swiper-slide v-for="(list,k) in qtz_banner" :key="k" class="swiper-slide" style="overflow:hidden;" >
                            <div class="banner section-content" v-if="list.url==222" >
                                <div class="banber-text">
                                    <div style="position: relative;z-index: 100;">
                                        <div class="banner-title">SHICHIDA</div>
                                        <div class="banner-detail">Education International</div>

                                        <div class="zh-text" style="">基础认知能力培养是</div>
                                        <div class="zh-text-bold">早期教育的必修课</div>
                                    </div>
                                    <img class="banner-img" src="../../assets/imgs/index-banner.jpg" alt="">
                                </div>
                            </div>
                            <img v-else class="banner-img"  style="height:970px; margin-left: 50%; transform: translateX(-50%);" :src="list.Img[0].url" alt="">
                        </swiper-slide>

                </swiper>
            </div>
        <!-- </div> -->


<!--最新新闻-->
        <div class="news" style="margin-top: 0">
            <div class="section-content border-top">
                <div class="news-header">
                    <div><span>HOT</span> 头条新闻</div>
                    <div style="cursor: pointer"><router-link to="/news" style="color: #616161;text-decoration: none">查看更多 ></router-link></div>
                </div>
                <div class="header-content">
                    <img v-for="(item,i) in newsList" :key="i" @click="_open(item.ImgLink,i+1)" :src="item.Img.url" />
                </div>
            </div>
        </div>

<!--七田真简介-->
        <div class="section-content qtz-intro">
            <div class="intro-text">
                <div class="intro-title">七田真是什么？</div>
                <div class="en-title">What is SHICHIDA</div>
                <div class="heng"></div>
                <div class="intro-detail">
                    七田真以<span>全人格</span>为目标、<span>脑力开发</span>为特色，
                    用<span>科学</span>的方法，通过<span>爱与感动</span>培养 <span>孩子才能</span>，
                    为<span>爱心家庭</span>提供<span>先进</span>的<span>教育方式</span>。
                </div>
            </div>
            <div class="line"></div>
            <div class="intro-text" style="padding-left: 80px;">
                <div class="intro-title">七田真的效果</div>
                <div class="en-title" style="font-size: 24px;">Results of SHICHIDA education</div>
                <div class="effect-intro">
                    <div>践行七田真的 理念、方法，坚持上课，用好产品，</div>
                    <div>在孩子身体、人格和智力三方面，</div>
                    <div>能达到如下效果：</div>
                </div>
                <ul style="margin-top: 30px;">
                    <li style="display: inline-block;margin-right: 50px">
                        <div class="effect-pic">
                            <div>夯实</div>
                            <div>基础</div>
                        </div>
                        <div class="effect-right">学习不吃力</div>
                    </li>
                    <li style="display: inline-block">
                        <div class="effect-pic">
                            <div>挖掘</div>
                            <div>才能</div>
                        </div>
                        <div class="effect-right" style="font-size: 15px">成就更好自己</div>
                    </li>
                </ul>
            </div>
        </div>
<!--科学育儿推荐-->
        <div class="recommend">
            <div class="section-content">
                <div class="recommend-icon" @click="_skipParents">
                    <div>科学育儿推荐</div>
                    <img src="../../assets/imgs/recommend-icon-bg.png" alt="">
                </div>
                <ul class="tags-btn">
                    <li v-for="(item,index) in tagList" :key="index" @click="_recommendActive(index)" :class="recommendActive==index?'active':''" v-text="item.title"></li>
                </ul>
            </div>
        </div>
        <div class="section-content" style="position: relative;z-index: 100">
            <div class="tags-view">
                <ul v-if="tagList[recommendActive]">
                    <li v-for="(item,index) in tagList[recommendActive].list" :key="index" v-show="index<3" @click="_skipNewsDetails(item.id)">
                        <img :src="item.video_pic" alt="">
                        <div class="description">
                            <div class="description-title" v-text="item.title"></div>
                            <div class="description-text" >{{item.simple_description.length>60?item.simple_description.slice(0,50)+'...':item.simple_description}}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tag-bg">
            <img src="../../assets/imgs/tag-bg.png" alt="">
        </div>
<!--地图-->
        <div class="map section-content">
            <div style="width: 800px;height: 470px;overflow: scroll">
                <div class="map-view" >
                    <img src="../../assets/imgs/map-1.jpg" id="map" :style="style" @drop="_mousePic" @mousedown="start" @dragover="dragover" @mousewheel.prevent="rollImg(this)" ref="bigImage">
                </div>
            </div>

            <div class="map-describe">
                <div class="map-title">A brand with profound cultural background</div>
                <div class="brand">有底蕴的品牌</div>
                <ul>
                    <li>65 年历史</li>
                    <li>200 多本书籍</li>
                    <li>720 篇教案全球同步更新</li>
                    <li>19 个国家和地区</li>
                </ul>
            </div>
        </div>

        <div class="section-content">
            <div class="centre-sort">
                <div class="centre-sort-title">按照进驻时间顺序排列</div>
                <ul>
                    <li>日本</li>
                    <li>中国台湾</li>
                    <li>新加坡</li>
                    <li>美国</li>
                    <li>印度尼西亚</li>
                    <li>加拿大</li>
                    <li>泰国</li>
                    <li>澳大利亚</li>
                    <li>中国</li>
                    <li>中国香港</li>
                    <li>越南</li>
                    <li>老挝</li>
                    <li>缅甸</li>
                    <li>柬埔寨</li>
                    <li>英国</li>
                    <li>罗马尼亚</li>
                    <li>印度</li>
                    <li>韩国</li>
                </ul>
                <div class="page-btn" @click="_skipQTZ">查看海外七田真</div>
            </div>
        </div>
        
    </div>
</template>
<script>

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

    export default {

        data(){
            return{

                recommendActive: 0,
                x0:0,
                y0:0,
                x1:0,
                y1:0,
                style:'left:-3089px;top: -825px;',
                newsList: '',
                tagList: '',
                imgbool: 1,
                qtz_banner: [],
                 swiperOption: {
                    autoplay: {
                       delay: 3000,
                       disableOninteraction: true
                    },
                    loop: true
                },
                NowStatus:0,
               

            }
        },

        components: {
            Swiper,
           SwiperSlide
        },
          directives: {
            swiper: directive
        },
        created(){
            let loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.$http.get('https://q.qitianzhen.cn/api/index_adv').then((res) => {
                this.newsList = res.data.list;
                loading.close();
            });

            this.$http.get('https://q.qitianzhen.cn/api/babies').then((res) => {
                this.tagList = res.data;
                loading.close();
            });
            this.$http.get('https://q.qitianzhen.cn/api/qtz_banner').then((res) => {
                // this.qtz_banner = res.data.list[0]?res.data.list[0].Img:[];
                this.qtz_banner = res.data.list;
                this.qtz_banner.unshift({url:222});
                loading.close();
            });


            let day2 = new Date();
            day2.setTime(day2.getTime());
            let month = day2.getMonth()+1;
            if(month>=10){
                this.NowStatus =1;
            }
        },

        methods:{

            _bannerLink(){
                this.$router.push({path:'/nineMonth'})
            },
            rollImg() {
                /* 获取当前页面的缩放比
                      若未设置zoom缩放比，则为默认100%，即1，原图大小
                  */
                var zoom = parseInt(this.$refs.bigImage.style.zoom) || 100;
                /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
                      wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
                  */
                zoom += event.wheelDelta / 12;
                /* 最小范围 和 最大范围 的图片缩放尺度 */
                if (zoom >= 100 && zoom <250) {
                    this.$refs.bigImage.style.zoom = zoom + "%";
                }
                return false;
            },
            note(){
               window.location.href='https://q.qitianzhen.cn/Index/note';
            },
            // createMap () {
            //     var map = new BMap.Map("map");
            //     // 初始化地图,设置中心点坐标和地图级别
            //     map.centerAndZoom(new BMap.Point(121.103108,23.944082), 2);
            //     map.setCurrentCity("深圳");

            //     var myIcon = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/jp_riben.png?imageView2/2/w/30/h/20", new BMap.Size(30, 20));
            //     let marker = new BMap.Marker(new BMap.Point(139.687913,35.813131),{icon:myIcon});
            //     // marker.setIcon(myIcon);
            //     map.addOverlay(marker);

            //     var myIcon2 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/cn_zhongguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker2 = new BMap.Marker(new BMap.Point(121.015721,23.85739));
            //     map.addOverlay(marker2);

            //     var myIcon3 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/sg_xinjiapo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker3 = new BMap.Marker(new BMap.Point(103.791665,1.662518),{icon:myIcon3});
            //     map.addOverlay(marker3);

            //     //泰国
            //     var myIcon4 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/th_taiguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker4 = new BMap.Marker(new BMap.Point(100.483741,13.743748),{icon:myIcon4});
            //     map.addOverlay(marker4);

            //     //美国
            //     var myIcon5 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/us_meiguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker5 = new BMap.Marker(new BMap.Point(-74.197252,41.134065),{icon:myIcon5});
            //     map.addOverlay(marker5);

            //     //印度尼西亚
            //     var myIcon6 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/id_yidunixiya.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker6 = new BMap.Marker(new BMap.Point(114.487044,0.125546),{icon:myIcon6});
            //     map.addOverlay(marker6);

            //     //加拿大
            //     var myIcon7 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/ca_jianada.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker7 = new BMap.Marker(new BMap.Point(-107.671376,56.887415),{icon:myIcon7});
            //     map.addOverlay(marker7);

            //     //澳大利亚
            //     var myIcon8 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/au_aodaliya.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker8 = new BMap.Marker(new BMap.Point(133.479629,-24.922317),{icon:myIcon8});
            //     map.addOverlay(marker8);

            //     //中国
            //     var myIcon9 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/cn_zhongguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker9 = new BMap.Marker(new BMap.Point(113.645166,24.180176),{icon:myIcon9});
            //     map.addOverlay(marker9);

            //     //中国香港
            //     var myIcon10 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/hk_xianggang.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker10 = new BMap.Marker(new BMap.Point(114.167728,22.269774),{icon:myIcon10});
            //     map.addOverlay(marker10);

            //     //越南
            //     var myIcon11 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/vn_yuenan.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker11 = new BMap.Marker(new BMap.Point(108.535336,14.268422),{icon:myIcon11});
            //     map.addOverlay(marker11);

            //     //老挝
            //     var myIcon12 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/la_laowo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker12 = new BMap.Marker(new BMap.Point(103.087659,19.664939),{icon:myIcon12});
            //     map.addOverlay(marker12);

            //     //缅甸
            //     var myIcon13 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/mm_miandian.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker13 = new BMap.Marker(new BMap.Point(96.63035,21.718384),{icon:myIcon13});
            //     map.addOverlay(marker13);

            //     //柬埔寨
            //     var myIcon14 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/kh_jianpuzhai.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker14 = new BMap.Marker(new BMap.Point(104.867356,12.436592),{icon:myIcon14});
            //     map.addOverlay(marker14);

            //     //英国
            //     var myIcon15 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/gb_yingguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker15 = new BMap.Marker(new BMap.Point(-2.989839,55.482178),{icon:myIcon15});
            //     map.addOverlay(marker15);

            //     //罗马尼亚
            //     var myIcon16 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/ro_luomaniya.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker16 = new BMap.Marker(new BMap.Point(25.143834,45.987862),{icon:myIcon16});
            //     map.addOverlay(marker16);

            //     //印度
            //     var myIcon17 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/in_yindu.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker17 = new BMap.Marker(new BMap.Point(79.014622,20.435786),{icon:myIcon17});
            //     map.addOverlay(marker17);

            //     //韩国
            //     var myIcon18 = new BMap.Icon("https://smart-resource.sikegroup.com/map/icon/kr_hanguo.png?imageView2/2/w/30/h/20", new BMap.Size(30,20));
            //     let marker18 = new BMap.Marker(new BMap.Point(127.281693,35.530087),{icon:myIcon18});
            //     map.addOverlay(marker18);




            //     //开启鼠标滚轮缩放
            //     map.enableScrollWheelZoom(true);
            // },
            _skipQTZ(){
                window.location.href = 'https://www.shichida.co.jp/';
            },
            _skipNewsDetails(id){
                this.$router.push({path:'/news-details',query:{id:id,tabIndex:this.recommendActive,type:2}})
            },
            _skipParents(){
                this.$router.push({path:'/parents'})
            },
            _open(url){
                // if(i==1){
                  window.open(url)
                // }else{
                //   window.location.href=url;
                // }
                // this.$router.push({path: '/news-details',query:{id:url}})
            },
            start:function(e){
                if(e.button==0){
                    //记录鼠标指针位置
                    this.x0=e.clientX;
                    this.y0=e.clientY;
                }
            },
            _mousePic(e){
                let x=e.clientX-this.x0;
                let y=e.clientY-this.y0;
                let img=document.querySelector(".map-view img");
                this.style=`left:${img.offsetLeft+x}px;top:${img.offsetTop+y}px`;
                this.x0=e.clientX;
                this.y0=e.clientY;
            },
            dragover(e){
                e.preventDefault()
            },
            _recommendActive(i){
                this.recommendActive = i;
            }
        }
    }

</script>
<style lang="less">
    .index{
        padding-bottom: 50px;
        background: #FDFCFA;
        .banner{
            img{
                vertical-align: middle;
                width: 1320px;
                height: 100%;
            }
            .banber-text{
                position: relative;
                padding-top: 190px;
                height: 950px;
                .banner-title{
                    font-family: Heavy;
                    font-size: 130px;
                    font-weight: bold;
                    color: #F9BF45;
                    line-height: 1;
                }
                .banner-detail{
                    font-weight: 600;
                    font-size: 65px;
                    color: #655C50;
                    line-height: 1;
                }
                .zh-text{
                    padding-top: 90px;
                    font-weight: 600;
                    font-size: 39px;
                    color: #655C50;
                }
                .zh-text-bold{
                    font-size: 70px;
                    font-weight: bold;
                    color: #655B51;
                }
                .banner-img{
                    position: absolute;
                    top: 0;
                    right: -360px;
                    width: 1320px;
                    height: 970px;
                }
            }
        }
        .news{
            width: 1360px;
            margin: 0 auto;
            margin-top: -140px;
            padding-bottom: 50px;
            background: #fff;
            border: 1px solid #F3F3F3;
            border-radius: 8px;
            position: relative;
            z-index: 100;
            .border-top{
                top: -1px;
                border-top: 5px solid #FBAD25;
            }
            .news-header{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 35px 0;
                font-weight: normal;
                font-size: 20px;
                color: #616161;
                span{
                    font-family: Heavy;
                    font-size: 30px;
                    color: #FBAD25;
                }
            }
            .header-content{
                display: flex;
                justify-content: space-between;
                align-items: center;
                img{
                    width: 280px;
                    height: 170px;
                    cursor: pointer;
                }
            }
        }
        .qtz-intro{
            text-align: center;
            display: flex;
            justify-content: center;
            padding: 65px 0;
            .intro-text{
                &:first-child{
                    border-right: 1px solid #F1F1F1;
                }
                width: 500px;
                padding-right: 15px;
                text-align: left;
                .intro-title{
                    font-weight: 600;
                    font-size: 36px;
                    color: #474747;
                }
                .en-title{
                    font-size: 36px;
                    font-weight: 600;
                    color: #F9BF45;
                }
                .effect-intro{
                    font-family: Light;
                    color:#646361;
                    font-size: 16px;
                    margin-top: 20px;
                    line-height: 1.8;
                }
                .heng{
                    width: 62px;
                    height: 4px;
                    margin-top: 30px;
                    background: #F9BF45;
                }
                .intro-detail{
                    margin-top: 80px;
                    font-size: 20px;
                    color: #676767;
                    line-height: 1.6;
                    span{
                        display: inline-block;
                        margin: 0 4px;
                        color: #F9BE46;
                        font-size: 22px;
                    }
                }
                .effect-pic{
                    display: inline-block;
                    line-height: 1;
                    color: #F9BF45;
                    font-family: TiB;
                    font-size: 50px;
                    font-weight: bold;
                }
                .effect-right{
                    display: inline-block;
                    font-size: 18px;
                    font-weight: 600;
                    width: 25px;
                    line-height: 1.2;
                    vertical-align: top;
                    margin-left: 5px;
                    color: #474747;
                }
            }
        }
        .recommend{
            width: 1360px;
            height: 70px;
            margin: 0 auto;
            margin-top: 30px;
            background: #fff;
            border: 1px solid #F3F3F3;
            border-radius: 8px;
            .section-content{
                display: flex;
            }
            .recommend-icon{
                width: 345px;
                height: 84px;
                position: relative;
                margin-right: 120px;
                cursor: pointer;
                div{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                    color: #fff;
                    font-weight: 600;
                    font-size: 36px;
                    z-index: 100;
                    white-space: nowrap;
                    margin-top: -14px;
                }
                img{
                    position: relative;
                    top: -14px;
                    width: 100%;
                    height: 100%;
                }
            }
            .tags-btn{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 70px;
                flex: 1;
                li{
                    &.active{
                        border-top: 6px solid #FBAD25;
                    }
                    padding: 0 15px;
                    font-weight: normal;
                    line-height: 64px;
                    font-size: 24px;
                    color: #5F5F5F;
                    cursor: pointer;
                    border-top: 6px solid transparent;
                }
            }
        }
        .tags-view{
            width: 100%;
            margin-top: 50px;
            ul{
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                li{
                    width: 360px;
                    height: 260px;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .description{
                        margin-top: 20px;
                        .description-title{
                            margin-bottom: 25px;
                            font-weight: 600;
                            font-size: 20px;
                            color: #fff;
                            width: 100%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .description-text{
                            font-size: 15px;
                            color: #fff;
                        }
                    }
                }
            }
        }
        .tag-bg{
            width: 100%;
            height:280px;
            position: relative;
            top:-80px;
            img{
                width: 100%;
                height: 100%
            }
        }
        .map{
            display: flex;
            .map-view{
                position: relative;
                width: 4655px;
                height: 900px;
                overflow: hidden;
                img{
                    position: absolute;
                    cursor: grab;
                }
            }
            .map-describe{
                padding-top: 50px;
                flex: 1;
                padding-left: 60px;
                font-weight: 600;
                font-size: 30px;
                color: #F9BF45;
                ul{
                    font-size: 20px;
                    color: #80807F;
                    li{
                        line-height: 2;
                    }
                }
            }
            .brand{
                margin: 30px 0;
                font-weight: 600;
                font-size: 36px;
                color: #7D7C7C;
            }
        }
        .centre-sort{
            margin-top: 50px;
            font-family: Light;
            font-size: 14px;
            color: #919191;
            ul{
                width: 100%;
                margin-top: 30px;
                li{
                    display: inline-block;
                    vertical-align: middle;
                    width: 140px;
                    height: 70px;
                    line-height: 70px;
                    text-align: center;
                    background: #fff;
                    font-weight: normal;
                    color: #5e5e5e;
                    border-bottom: 1px solid #F3F3F3;
                    border-right: 1px solid #F3F3F3;
                }
            }
            .page-btn{
                display: inline-block;
                padding: 10px 20px;
                margin-top: 15px;
                color: #fff;
                font-weight: normal;
                font-size: 22px;
                border-radius: 40px;
                background: #2689D7;
                text-align: center;
                cursor: pointer;
            }
        }
    }
    .swiper-container {
        // width: 500px;
        // height: 300px;
        // margin: 20px auto;
    }
   
</style>
